<!-- Admin Classes Management - Bootstrap 5.3.7 Layout -->
<div class="admin-classes-container position-relative">
  <div class="page-disable-overlay bg-dark opacity-50 position-absolute w-100 h-100 top-0 start-0">

  </div>
  
  <!-- Page Header -->
  <div class="page-header bg-white border-bottom shadow-sm mb-4 sticky-top">
    <div class="container-fluid py-3">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h1 class="h3 mb-0 text-gray-800">
            <i class="fa fa-book me-2 text-primary"></i>
            Class Management
          </h1>
          <p class="text-muted mb-0">Manage video classes and settings</p>
        </div>
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-outline-success btn-sm">
            <i class="fa fa-plus me-1"></i>
            Add New Class
          </button>
          <button type="button" class="btn btn-outline-primary btn-sm">
            <i class="fa fa-sync me-1"></i>
            Refresh All
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="container-fluid pb-4" *ngIf="uclass && uclass.length >= 10">
    
    <!-- Classes Grid -->
    <div class="row g-4">

  <!-- Loading State -->
  <div class="container-fluid pb-4 text-center" *ngIf="!uclass || uclass.length < 10">
    <div class="card border-0 shadow-sm">
      <div class="card-body p-5">
        <div class="spinner-border text-primary mb-3" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <h5 class="text-muted">Loading Classes...</h5>
        <p class="text-muted mb-0">Please wait while we fetch the class data.</p>
      </div>
    </div>
  </div>

      <!-- Class 1 -->
      <div class="col-12 col-lg-6 col-xl-4">
        <form [formGroup]="classOneForm" (ngSubmit)="saveClass(0)">
          <div class="card border-0 shadow-sm h-100 class-card">
            <div class="card-header bg-primary bg-gradient text-white">
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="card-title mb-0">
                  <i class="fa fa-play-circle me-2"></i>
                  Class 1
                </h5>
                <div class="form-check form-switch">
                  <input 
                    class="form-check-input" 
                    [(ngModel)]="this.uclass[0].isActive" 
                    [ngModelOptions]="{standalone: true}"
                    name="isActive0" 
                    type="checkbox" 
                    id="formCheck-1">
                  <label class="form-check-label text-white" for="formCheck-1">
                    Active
                  </label>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="mb-3">
                <h6 class="text-primary fw-bold">{{this.uclass[0].title}}</h6>
              </div>
              
              <div class="mb-4">
                <label class="form-label text-uppercase text-primary fw-bold small">
                  <i class="fa fa-video me-1"></i>
                  Video URL
                </label>
                <div class="input-group">
                  <input 
                    type="url" 
                    class="form-control" 
                    value="{{this.uclass[0].videoUrl}}"
                    placeholder="Enter video URL">
                  <span class="input-group-text">
                    <i class="fa fa-external-link-alt text-muted"></i>
                  </span>
                </div>
              </div>
              
              <div class="d-grid">
                <button class="btn btn-primary" type="submit">
                  <i class="fa fa-save me-1"></i>
                  Save Settings
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Class 2 -->
      <div class="col-12 col-lg-6 col-xl-4">
        <form [formGroup]="classTwoForm" (ngSubmit)="saveClass(1)">
          <div class="card border-0 shadow-sm h-100 class-card">
            <div class="card-header bg-success bg-gradient text-white">
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="card-title mb-0">
                  <i class="fa fa-play-circle me-2"></i>
                  Class 2
                </h5>
                <div class="form-check form-switch">
                  <input 
                    class="form-check-input" 
                    [(ngModel)]="this.uclass[1].isActive" 
                    [ngModelOptions]="{standalone: true}"
                    name="isActive1" 
                    type="checkbox" 
                    id="formCheck-2">
                  <label class="form-check-label text-white" for="formCheck-10">
                    Active
                  </label>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="mb-3">
                <h6 class="text-success fw-bold">{{this.uclass[1].title}}</h6>
              </div>
              
              <div class="mb-4">
                <label class="form-label text-uppercase text-success fw-bold small">
                  <i class="fa fa-video me-1"></i>
                  Video URL
                </label>
                <div class="input-group">
                  <input 
                    type="url" 
                    class="form-control" 
                    value="{{this.uclass[1].videoUrl}}"
                    placeholder="Enter video URL">
                  <span class="input-group-text">
                    <i class="fa fa-external-link-alt text-muted"></i>
                  </span>
                </div>
              </div>
              
              <div class="d-grid">
                <button class="btn btn-success" type="submit">
                  <i class="fa fa-save me-1"></i>
                  Save Settings
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Class 3 -->
      <div class="col-12 col-lg-6 col-xl-4">
        <form [formGroup]="classThreeForm" (ngSubmit)="saveClass(2)">
          <div class="card border-0 shadow-sm h-100 class-card">
            <div class="card-header bg-info bg-gradient text-white">
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="card-title mb-0">
                  <i class="fa fa-play-circle me-2"></i>
                  Class 3
                </h5>
                <div class="form-check form-switch">
                  <input 
                    class="form-check-input" 
                    [(ngModel)]="this.uclass[2].isActive" 
                    [ngModelOptions]="{standalone: true}"
                    name="isActive2" 
                    type="checkbox" 
                    id="formCheck-3">
                  <label class="form-check-label text-white" for="formCheck-9">
                    Active
                  </label>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="mb-3">
                <h6 class="text-info fw-bold">{{this.uclass[2].title}}</h6>
              </div>
              
              <div class="mb-4">
                <label class="form-label text-uppercase text-info fw-bold small">
                  <i class="fa fa-video me-1"></i>
                  Video URL
                </label>
                <div class="input-group">
                  <input 
                    type="url" 
                    class="form-control" 
                    value="{{this.uclass[2].videoUrl}}"
                    placeholder="Enter video URL">
                  <span class="input-group-text">
                    <i class="fa fa-external-link-alt text-muted"></i>
                  </span>
                </div>
              </div>
              
              <div class="d-grid">
                <button class="btn btn-info" type="submit">
                  <i class="fa fa-save me-1"></i>
                  Save Settings
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Classes 4-6 -->
      <div class="col-12 col-lg-6 col-xl-4" *ngFor="let class of [3,4,5]; let i = index">
        <form [formGroup]="getFormGroup(3 + i)" (ngSubmit)="saveClass(3 + i)">
          <div class="card border-0 shadow-sm h-100 class-card">
            <div class="card-header bg-warning bg-gradient text-white">
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="card-title mb-0">
                  <i class="fa fa-play-circle me-2"></i>
                  Class {{4 + i}}
                </h5>
                <div class="form-check form-switch">
                  <input 
                    class="form-check-input" 
                    [(ngModel)]="this.uclass[3 + i].isActive" 
                    [ngModelOptions]="{standalone: true}"
                    [name]="'isActive' + (3 + i)" 
                    type="checkbox" 
                    [id]="'formCheck-' + (8 - i)">
                  <label class="form-check-label text-white" [for]="'formCheck-' + (8 - i)">
                    Active
                  </label>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="mb-3">
                <h6 class="text-warning fw-bold">{{this.uclass[3 + i].title}}</h6>
              </div>
              
              <div class="mb-4">
                <label class="form-label text-uppercase text-warning fw-bold small">
                  <i class="fa fa-video me-1"></i>
                  Video URL
                </label>
                <div class="input-group">
                  <input 
                    type="url" 
                    class="form-control" 
                    [value]="this.uclass[3 + i].videoUrl"
                    placeholder="Enter video URL">
                  <span class="input-group-text">
                    <i class="fa fa-external-link-alt text-muted"></i>
                  </span>
                </div>
              </div>
              
              <div class="d-grid">
                <button class="btn btn-warning" type="submit">
                  <i class="fa fa-save me-1"></i>
                  Save Settings
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Classes 7-10 -->
      <div class="col-12 col-lg-6 col-xl-4" *ngFor="let class of [6,7,8,9]; let i = index">
        <form [formGroup]="getFormGroup(6 + i)" (ngSubmit)="saveClass(6 + i)">
          <div class="card border-0 shadow-sm h-100 class-card">
            <div class="card-header bg-secondary bg-gradient text-white">
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="card-title mb-0">
                  <i class="fa fa-play-circle me-2"></i>
                  Class {{7 + i}}
                </h5>
                <div class="form-check form-switch">
                  <input 
                    class="form-check-input" 
                    [(ngModel)]="this.uclass[6 + i].isActive" 
                    [ngModelOptions]="{standalone: true}"
                    [name]="'isActive' + (6 + i)" 
                    type="checkbox" 
                    [id]="'formCheck-' + (5 - i)">
                  <label class="form-check-label text-white" [for]="'formCheck-' + (5 - i)">
                    Active
                  </label>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="mb-3">
                <h6 class="text-secondary fw-bold">{{this.uclass[6 + i].title}}</h6>
              </div>
              
              <div class="mb-4">
                <label class="form-label text-uppercase text-secondary fw-bold small">
                  <i class="fa fa-video me-1"></i>
                  Video URL
                </label>
                <div class="input-group">
                  <input 
                    type="url" 
                    class="form-control" 
                    [value]="this.uclass[6 + i].videoUrl"
                    placeholder="Enter video URL">
                  <span class="input-group-text">
                    <i class="fa fa-external-link-alt text-muted"></i>
                  </span>
                </div>
              </div>
              
              <div class="d-grid">
                <button class="btn btn-secondary" type="submit">
                  <i class="fa fa-save me-1"></i>
                  Save Settings
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

    </div>
  </div>
</div>